import React from 'react';
import PropTypes from 'prop-types';
import InlineLabel from 'wonderbly-components/lib/InlineLabel';
import Select from 'wonderbly-components/lib/Select';
import FieldDescription from '../Field/FieldDescription';
import FieldError from '../Field/FieldError';

const CountryDropdown = ({
  name,
  width,
  label,
  value,
  error,
  countries,
  description,
  onCountryChange,
}) => {
  const fieldId = `select_input--${name}`;
  return (
    <div className={`field-container select_input ${fieldId}`} style={{ width }}>
      <InlineLabel htmlFor={fieldId}>{label}</InlineLabel>
      <Select
        onChange={onCountryChange}
        value={value}
        options={countries}
        name={name}
        className="shipping-country-list"
        id={fieldId}
      />
      {error &&
        <FieldError
          message={error}
          visible
        />
      }
      <FieldDescription
        content={description}
      />
    </div>
  );
};

CountryDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  width: PropTypes.string,
  error: PropTypes.string,
  countries: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  description: PropTypes.array,
  onCountryChange: PropTypes.func.isRequired,
};

export default CountryDropdown;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/CountryDropdown/CountryDropdown.js